import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * 매입·매출 계산서 등록 내역 (통합).
 *
 * 예전에는 매입용·매출용 표가 따로 있었는데 컬럼 구조가 같았고,
 * 매입 표는 두 탭에 각각 걸려 있어 같은 내용이 화면에 두 번 나왔다.
 * 하나로 두고 구분 칸으로 나눈다.
 *
 * 삭제는 매입만 된다 — 매출은 발행 요청을 거쳐 나가는 것이라 여기서 지우면 안 된다.
 */
const fmt = (value) => {
  const n = Number(String(value ?? '').replace(/,/g, ''));
  return Number.isFinite(n) ? n.toLocaleString('ko-KR') : '0';
};

const BillHistoryList = ({ rows, isEdit, onDelete }) => {
  const list = rows || [];
  const colCount = isEdit ? 11 : 10;

  return (
    <Box sx={{ overflowX: 'auto', my: 1 }}>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'action.hover' }}>
              <TableCell align="center" sx={{ fontWeight: 700, width: 70 }}>구분</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700 }}>일자</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>거래처</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>내용</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700 }}>해외</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>총금액</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>합계</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>공급가액</TableCell>
              <TableCell align="right" sx={{ fontWeight: 700 }}>부가세</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700 }}>수금·지급 예정</TableCell>
              {isEdit && <TableCell align="center" sx={{ fontWeight: 700 }}>삭제</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {list.length === 0 ? (
              <TableRow>
                <TableCell colSpan={colCount} align="center" sx={{ py: 3, color: 'text.disabled' }}>
                  등록된 계산서가 없습니다.
                </TableCell>
              </TableRow>
            ) : list.map((item, index) => {
              const isPurchase = item.invTyp === '매입';
              return (
                <TableRow key={item.invUuid || index} hover>
                  <TableCell align="center">
                    <Chip
                      size="small"
                      variant="outlined"
                      label={item.invTyp || '-'}
                      color={isPurchase ? 'warning' : 'primary'}
                      sx={{ fontWeight: 600 }}
                    />
                  </TableCell>
                  <TableCell align="center">{item.reqCompDt || '-'}</TableCell>
                  <TableCell>{item.partnerNm || '-'}</TableCell>
                  <TableCell>{item.invTxt || '-'}</TableCell>
                  <TableCell align="center">{item.osTran || '-'}</TableCell>
                  <TableCell align="right">{fmt(item.billSumTotal)}</TableCell>
                  <TableCell align="right">{fmt(item.invTot)}</TableCell>
                  <TableCell align="right">{fmt(item.invAmt)}</TableCell>
                  <TableCell align="right">{fmt(item.invVat)}</TableCell>
                  <TableCell align="center">{item.prodCompDt || item.procPlanDt || '-'}</TableCell>
                  {isEdit && (
                    <TableCell align="center">
                      {/* 매출은 발행 요청을 거쳐 나간다. 여기서 지우면 그 흐름이 끊긴다. */}
                      {isPurchase ? (
                        <IconButton size="small" aria-label="삭제" onClick={() => onDelete(item)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        <Typography variant="caption" color="text.disabled">-</Typography>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BillHistoryList;
